import { getActiveBuildings } from "./index24.js";
import { setLevelData } from "@project-rouge/rg-three";
const pipeSetLevelData = ([parent, { buildingIds, aggProps }]) => {
	const dataset = aggProps.dataset;
	const buildings = getActiveBuildings(parent, aggProps);
	for (const building of buildings) {
		if (buildingIds && !buildingIds.includes(building.uuid)) continue;
		setLevelData(building, dataset.id);
	}
	return [parent, void 0];
};
export { pipeSetLevelData };

//# sourceMappingURL=index181.js.map